const VUE_EDITORS_CSS_ATTR = "data-vue-editors-css"

let vueEditorsModulePromise = null
let vueEditorsModule = null

function findMetaContent(name) {
  return document.querySelector(`meta[name="${name}"]`)?.getAttribute("content") || ""
}

function editorMountPointsPresent(root = document) {
  return Boolean(root.getElementById?.("qr-label-editor") || root.getElementById?.("barcode-label-editor"))
}

function ensureVueEditorsCssLoaded() {
  if (document.querySelector(`link[${VUE_EDITORS_CSS_ATTR}="true"]`)) return

  const href = findMetaContent("vue-editors-css-url")
  if (!href) return

  const link = document.createElement("link")
  link.rel = "stylesheet"
  link.href = href
  link.setAttribute(VUE_EDITORS_CSS_ATTR, "true")
  document.head.appendChild(link)
}

async function ensureVueEditorsJsLoaded() {
  if (vueEditorsModule) return vueEditorsModule

  const jsUrl = findMetaContent("vue-editors-js-url")
  if (!jsUrl) return null

  if (!vueEditorsModulePromise) {
    vueEditorsModulePromise = import(jsUrl)
      .then(mod => {
        vueEditorsModule = mod
        return mod
      })
      .catch(error => {
        vueEditorsModulePromise = null
        console.error("Failed to load vue_editors bundle", error)
        return null
      })
  }

  return vueEditorsModulePromise
}

async function maybeMountVueEditors() {
  if (!editorMountPointsPresent()) return

  ensureVueEditorsCssLoaded()

  const mod = await ensureVueEditorsJsLoaded()
  if (!mod?.mountVueEditors) return

  mod.mountVueEditors()
}

function cleanupVueEditors() {
  vueEditorsModule?.cleanupVueEditors?.()
}

document.addEventListener("DOMContentLoaded", () => void maybeMountVueEditors())
document.addEventListener("turbo:load", () => void maybeMountVueEditors())
document.addEventListener("turbo:frame-load", event => {
  const frame = event.target
  if (frame instanceof Element && editorMountPointsPresent(frame)) {
    void maybeMountVueEditors()
  }
})
document.addEventListener("turbo:before-cache", cleanupVueEditors)
